import React from "react";
import PropTypes from "prop-types";

import { generateClassString } from "../../lib/helper/generateClassString";

import * as styles from "./grid.module.less";

function Grid({ className, size, ...props }) {
    return (
        <div
            className={generateClassString(
                styles.gridOnly,
                styles[`grid${size.toUpperCase()}`],
                className
            )}
            {...props}
        />
    );
}

Grid.propTypes = {
    size: PropTypes.string.isRequired
};

export { Grid }